import React, { useContext, useState } from "react";
import "../css/accountantsReport.scss";
import {
  dateTimeFormatter,
  quarterMonthBookends,
  monthQuarters,
  getEndOfMonth,
  // startOfQuarters,
  // endOfQuarters,
  // quartersAvailable,
} from "../helperFunctions/dateFormatters";
// import Footer from "./Footer";
import {
  // doThis,
  // getYears,
  // generateAccountantsReport,
  // processReport,
  addJobsToTimesheets,
  getTopLevelTimesheets,
  // processReports,
  processTimesheets,
  createCSVData,
} from "../helperFunctions/accountantFunctions";
import { AuthContext } from "../providers/AuthProvider";
// import { ContactsOutlined } from "@mui/icons-material";
// import SaveIcon from "@mui/icons-material/Save";

let defaultColumns = [
  { label: "HES No", key: "refNumber", checked: true },
  { label: "W/O No", key: "worksOrderNumber", checked: false },
  { label: "Hours", key: "hours", checked: true },
  { label: "Labour", key: "labour", checked: true },
  { label: "Materials (base)", key: "baseMaterials", style: { width: "130px" }, checked: true },
  { label: "Markup", key: "markup", checked: true },
  { label: "Materials", key: "materials", checked: true },
  { label: "Net", key: "net", checked: true },
  { label: "VR(%)", key: "vr", checked: false },
  { label: "VAT", key: "vat", checked: true },
  { label: "Gross", key: "gross", checked: true },
  // { label: "Total", key: "total", checked: false },
];

const AccountantsReport = () => {
  const { userData } = useContext(AuthContext);

  // const [accountsData, setAccountsData] = useState([]);
  const [csvData, setCsvData] = useState(null);

  const [generatedCustomerGroups, setCustomerGroups] = useState(null);
  const [total, setTotal] = useState(null);

  const todaysDate = new Date();
  const thisMonth = todaysDate.getMonth() + 1;
  const [currentYear] = useState(todaysDate.getFullYear());
  const thisQuarter = monthQuarters[thisMonth];

  // Default Start and End months are the starting/ending months for the quarter
  let [defaultStartMonth, defaultEndMonth] = quarterMonthBookends[thisQuarter];
  const startOfMonth = "01";
  const endOfMonth = getEndOfMonth(defaultEndMonth, currentYear);

  // Specific fields for the Select by Quarter inputs
  // const [startQuarter, setStartQuarter] = useState(monthQuarters[thisMonth]);
  // const [endQuarter, setEndQuarter] = useState(monthQuarters[thisMonth]);
  // const [startYear, setStartYear] = useState(currentYear);
  // const [endYear, setEndYear] = useState(currentYear);

  // Fields for the specific date that you want to start and end from
  const [startDate, setStartDate] = useState(
    dateTimeFormatter(new Date(currentYear, defaultStartMonth - 1, startOfMonth), "d_full_variant"),
  );
  const [endDate, setEndDate] = useState(
    dateTimeFormatter(new Date(currentYear, defaultEndMonth - 1, endOfMonth), "d_full_variant"),
  );

  const [fields, setFields] = useState([...defaultColumns]);

  const [err, setErr] = useState("");

  // let yearsAvailable = getYears();

  function dateHandler(e) {
    let name = e.target.name;
    let value = e.target.value;

    switch (name) {
      case "startDate": {
        setStartDate(value);
        break;
      }
      case "endDate": {
        setEndDate(value);
        break;
      }
      default: {
        return;
      }
    }
  }

  // function inputChange(e) {
  //   let name = e.target.name;
  //   let value = e.target.value;

  //   switch (name) {
  //     case "startYear": {
  //       setStartYear(value);
  //       let startDateMonth = new Date(startDate).getMonth();
  //       let startDateDay = new Date(startDate).getDate();
  //       let newStartDate = new Date(value, startDateMonth, startDateDay);

  //       setStartDate(dateTimeFormatter(newStartDate), "d_full_variant");
  //       break;
  //     }
  //     case "startQuarter": {
  //       setStartQuarter(value);
  //       let startDateYear = new Date(startDate).getFullYear();
  //       let startDateMonth = startOfQuarters[String(value)];
  //       let newStartDate = new Date(startDateYear, startDateMonth, "01");

  //       setStartDate(dateTimeFormatter(newStartDate), "d_full_variant");
  //       break;
  //     }
  //     case "endYear": {
  //       setEndYear(value);
  //       let endDateMonth = new Date(endDate).getMonth();
  //       let endDateDay = new Date(endDate).getDate();
  //       let newEndDate = new Date(value, endDateMonth, endDateDay);

  //       setEndDate(dateTimeFormatter(newEndDate), "d_full_variant");
  //       break;

  //       // setEndYear(value);
  //       // setEndDate(value, thisMonth - 1, getEndOfMonth(thisMonth, value));
  //       // break;
  //     }
  //     case "endQuarter": {
  //       setEndQuarter(value);
  //       let endDateYear = new Date(endDate).getFullYear();
  //       let endDateMonth = endOfQuarters[String(value)];
  //       let endDateDay = getEndOfMonth(Number(endDateMonth) + 1, endDateYear);

  //       let newEndDate = new Date(endDateYear, endDateMonth, endDateDay);

  //       setEndDate(dateTimeFormatter(newEndDate), "d_full_variant");
  //       break;
  //     }
  //     default: {
  //       console.log("Error changing input", name, value);
  //     }
  //   }
  // }

  // Make two inputs: start date and end date
  // When dates are entered, get timesheets from between these dates
  // From this data perform the calculations to get the data needed for the accountants report
  // Make an accountants reports table
  // Make sure it can be printed from a desktop

  async function genReport() {
    setCsvData(null);
    setCustomerGroups(null);

    if (new Date(endDate) < new Date(startDate)) {
      setErr("Sorry this isn't a time machine");
    } else if (!endDate || !startDate) {
      setErr("Need to pick valid dates ya ninny");
    } else {
      setErr("");
      let topLevelTimesheets = await getTopLevelTimesheets(userData, startDate, endDate);
      let timesheets = await addJobsToTimesheets(topLevelTimesheets);
      let [customerGroups, totalOverPeriod] = processTimesheets(timesheets);
      // console.log("customer groups,", customerGroups);
      // console.log("totla over period", totalOverPeriod);
      let csvData = createCSVData(customerGroups, totalOverPeriod, fields);
      // console.log("csv data", csvData);
      // Ste csv data here to be used in react link
      setCsvData(csvData);
      setCustomerGroups(customerGroups.customerTotals);
      setTotal(totalOverPeriod);

      // timesheets.forEach((ts) => {
      //   console.log("TS::", ts);
      //   ts.jobDescriptions.forEach((job) => {
      //     console.log("job", job);
      //   });
      // });

      // let data = await processTimesheets(timesheets);
    }
  }

  let tableColSpan = "9";

  function changeFields(key, checked) {
    let tempFields = [...fields];

    let newFields = tempFields.map((field) => {
      if (field.key === key) {
        return { ...field, checked: !checked };
      } else {
        return field;
      }
    });

    setFields([...newFields]);
  }

  function shiftArray(i, fieldKey, isMovingLeft) {
    let moveToIndex = isMovingLeft ? i - 1 : i + 1;
    let moveFromIndex = i;
    const changeValuePosition = (arr, moveFrom, moveToIndex) => {
      [arr[moveFrom], arr[moveToIndex]] = [arr[moveToIndex], arr[moveFrom]];
      return arr;
    };
    let newArray = changeValuePosition(fields, moveFromIndex, moveToIndex);

    setFields([...newArray]);
  }

  function sortLines(lines) {
    lines.sort(function (a, b) {
      if (isNaN(Number(a.refNumber)) || isNaN(Number(b.refNumber))) {
        return false;
      }

      return Number(a.refNumber) - Number(b.refNumber);
    });

    return lines;
  }

  // console.log("Generated customer groups", generatedCustomerGroups);

  // for (let key in generatedCustomerGroups) {
  //   // console.log("generatedCustomerGroup", generatedCustomerGroups[key]?.lines);
  //   if (generatedCustomerGroups[key]?.lines) {
  //     let newArray = generatedCustomerGroups[key].lines.sort((a, b) => {
  //       // console.log("Group", group);
  //       // console.log("a", a);
  //       let aNum = Number(a.refNumber);
  //       let bNum = Number(b.refNumber);

  //       console.log("a, ", aNum);
  //       console.log("b, ", bNum);

  //       console.log("aNum < bNum", aNum < bNum);
  //       console.log("aNum > bNum", aNum > bNum);

  //       return aNum < bNum;
  //     });

  //     newArray.map((p) => {
  //       console.log("p.refNumber", p.refNumber);
  //     });
  //   }
  // }

  return (
    <div className="accountants-report-page">
      {/* Start of Controls for Accounts */}
      <div className="accounts-date-controls-container">
        {/* <div className="by-quarter-selection">
          <div className=".start-quarter-selection quarter-selection">
            <p>Start</p>
            <select
              name="startYear"
              value={startYear}
              onChange={inputChange}
              className="year-select"
            >
              {yearsAvailable.map((year) => {
                return (
                  <option key={year} value={year}>
                    {year}
                  </option>
                );
              })}
            </select>

            <select
              value={startQuarter}
              name="startQuarter"
              onChange={inputChange}
              className="quarter-select"
            >
              {quartersAvailable.map(({ monthNumber, description }) => {
                return (
                  <option key={monthNumber} value={monthNumber}>
                    {description}
                  </option>
                );
              })}
            </select>
          </div>

          <div className=".end-quarter-selection quarter-selection">
            <p>End</p>
            <select
              name="endYear"
              value={endYear}
              onChange={inputChange}
              className="year-select"
            >
              {yearsAvailable.map((year) => {
                return (
                  <option key={year} value={year}>
                    {year}
                  </option>
                );
              })}
            </select>

            <select
              value={endQuarter}
              name="endQuarter"
              onChange={inputChange}
              className="quarter-select"
            >
              {quartersAvailable.map(({ monthNumber, description }) => {
                return (
                  <option key={monthNumber} value={monthNumber}>
                    {description}
                  </option>
                );
              })}
            </select>
          </div>
        </div> */}

        <div className="by-specific-date-selection">
          <div className="start-date-selection date-selection">
            <p>Start Date</p>
            <input
              id="startDate"
              name="startDate"
              type="date"
              value={startDate}
              onChange={dateHandler}
              // onBlur={saveInput}
            />
          </div>
          <div className="end-date-selection date-selection">
            <p>End Date</p>
            <input
              id="endDate"
              name="endDate"
              type="date"
              value={endDate}
              onChange={dateHandler}
              // onBlur={saveInput}
            />
          </div>
        </div>

        <div className="dates-picked-container">
          <p>Start: {dateTimeFormatter(startDate, "d_full")}</p>
          <p>End: {dateTimeFormatter(endDate, "d_full")}</p>
          <button onClick={genReport}>Generate Accounts</button>
          <p>{err}</p>
        </div>
      </div>

      <div className="checkboxes_toolbar">
        <button
          onClick={() => {
            setFields([...defaultColumns]);
          }}
        >
          Default
        </button>
      </div>
      <div className="show_checkboxes">
        {fields.map(({ key, checked, label }, i) => {
          return (
            <div key={`${key}-${i}`} className="field_column">
              <div className="shift_controls">
                <button disabled={i === 0} onClick={() => shiftArray(i, key, true)}>
                  {"<"}
                </button>
                <button disabled={i === fields.length - 1} onClick={() => shiftArray(i, key, false)}>
                  {">"}
                </button>
              </div>

              <label htmlFor={key}>{label}</label>
              <input
                type="checkbox"
                id={key}
                name={key}
                checked={checked}
                onChange={() => changeFields(key, checked)}
              />
            </div>
          );
        })}
      </div>
      {/* End of Controls */}
      {/* Start of Table */}

      {generatedCustomerGroups && (
        <table align="center" className="accountants_report_table">
          <caption>
            <a
              type="text/csv"
              download={csvData ? "accountants_report.csv" : null}
              href={csvData && csvData}
            >
              Accounts for: {dateTimeFormatter(startDate, "d_full")} to{" "}
              {dateTimeFormatter(endDate, "d_full")}
            </a>
          </caption>
          <colgroup className="col_test" span={2} />
          <colgroup span={6} />

          {/* Table Header */}
          <thead>
            <tr className="table_header">
              {fields.map((field) => {
                if (field.checked) {
                  return (
                    <th key={field.key} style={field.style}>
                      {field.label}
                    </th>
                  );
                } else return null;
              })}
            </tr>
          </thead>

          <tbody>
            {/* Display customer specific rows */}
            {Object.keys(generatedCustomerGroups).map((item, i) => {
              let customerLines = generatedCustomerGroups[item].lines;
              let customerTotal = generatedCustomerGroups[item].total;

              sortLines(customerLines);

              let {
                // hours,
                total,
                // labour,
                // materials,
                // baseMaterials,
                // markup,
                // vr,
                // vat,
                // gross,
                // net,
              } = customerTotal;
              // console.log("cus groups", generatedCustomerGroups);
              // console.log("cus item", generatedCustomerGroups[item]);

              return (
                <>
                  {/* Free space before new customer */}
                  <tr className="free_space_row">
                    <td colspan={tableColSpan}></td>
                  </tr>

                  {/* Customer summary before their table data */}
                  <tr className="customer_summary">
                    <td colspan={tableColSpan}>
                      {item} - £{total}
                    </td>
                  </tr>
                  {/* <tr className="customer_summary">
                    <td className="last" colspan={tableColSpan}>
                      £{total}
                    </td>
                  </tr> */}

                  {/* Display individual invoices specific to this customer */}
                  {customerLines.map((line, i) => {
                    return (
                      <tr key={i} className="customer_line">
                        {fields.map((field, i) => {
                          if (field.checked) return <td key={i}>{line[field.key]}</td>;
                          else return null;
                        })}
                        {/* <td>{line.refNumber}</td>
                        <td>{line.worksOrderNumber}</td>

                        <td>{line.hours}</td>
                        <td>{line.labour}</td>
                        <td>{line.materials}</td>
                        <td>{line.baseMaterials}</td>
                        <td>{line.markup}</td>
                        <td>{line.gross}</td>
                        <td>{line.net}</td>
                        <td>{line.vr || 0}</td>
                        <td>{line.vat}</td> */}
                        {/* <td>{line.total}</td> */}
                      </tr>
                    );
                  })}

                  {/* Display a total for this customer */}
                  <tr className="customer_total">
                    {/* <td> --- </td>
                    <td> --- </td> */}
                    {fields.map((field, i) => {
                      if (field.checked)
                        return (
                          <td key={i}>
                            <span className="customer_total_label">{field.label}</span>
                            <span>{customerTotal[field.key]}</span>
                          </td>
                        );
                      else return null;
                    })}
                    {/* <td>{hours}</td>
                    <td>£{labour}</td>
                    <td>£{materials}</td>
                    {/* <td>£{markup}</td> */}
                    {/* <td>£{gross.toFixed(2)}</td> */}
                    {/* <td>£{net.toFixed(2)}</td> */}
                    {/* <td>£{vr || 0}</td> */}
                    {/* <td>£{vat}</td> */}
                    {/* <td>£{total.toFixed(2)}</td> */}
                  </tr>
                </>
              );
            })}
          </tbody>

          {/* Display total for all customers */}
          {/* <tfoot> */}
          {total && (
            <>
              <tr className="free_space_row">
                <td colspan={tableColSpan}></td>
              </tr>
              <tr className="free_space_row">
                <td colspan={tableColSpan}></td>
              </tr>

              <tr className="customers_total">
                {fields.map((field, i) => {
                  if (field.checked)
                    return (
                      <td key={i}>
                        <span className="customers_total_label">{field.label}</span>
                        <span>{total[field.key]}</span>
                      </td>
                    );
                  else return null;
                })}
                {/* <td> --- </td>
                  <td> --- </td>
                  <td>{total.hours}</td>
                  <td>£{total.labour}</td>
                  <td>£{total.materials}</td>
                  {/* <td>£{total.baseMaterials.toFixed(2)}</td>
                  <td>£{total.markup.toFixed(2)}</td>
                  <td>£{total.gross}</td>
                  <td>£{total.net}</td>
                  <td>{total?.vr || 0}% </td>
                  <td>£{total.vat}</td> 
                  <td>£{total.total}</td>*/}
              </tr>
            </>
          )}
          {/* </tfoot> */}
        </table>
      )}

      {/* End of Table */}
    </div>
  );
};

export default AccountantsReport;
